import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../firebase/config"; // Import Firebase config
import { collection, query, orderBy, limit, getDocs } from "firebase/firestore";

export const fetchHomeProducts = createAsyncThunk("home/fetchProducts", async () => {
  try {
    const productsRef = collection(db, "products");

    // Fetch All (Limit to 8)
    const allQuery = query(productsRef, limit(8));
    const allSnapshot = await getDocs(allQuery);
    const allProducts = allSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    // Fetch New Arrivals (Sort by createdAt DESC)
    const newArrivalsQuery = query(productsRef, orderBy("createdAt", "desc"), limit(8));
    const newSnapshot = await getDocs(newArrivalsQuery);
    const newArrivals = newSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    // Fetch Top Rated (Sort by totalPeopleReview DESC)
    const topRatedQuery = query(productsRef, orderBy("totalPeopleReview", "desc"), limit(8));
    const topRatedSnapshot = await getDocs(topRatedQuery);
    const topRated = topRatedSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    // Fetch Top Rated (Sort by totalPeopleReview DESC)
    const limitedEditionQuery = query(productsRef, orderBy("availableStock", "asc"), limit(8));
    const limitedEditionSnapshot = await getDocs(limitedEditionQuery );
    const limitedEdition = limitedEditionSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));    
    
    
    return { allProducts, newArrivals, topRated, limitedEdition };
  } catch (error) {
    console.error("Error fetching home products:", error);
    throw error;
  }
});

// Create Redux Slice
const homeSlice = createSlice({
  name: "home",
  initialState: {
    allProducts: [],
    newArrivals: [],
    topRated: [],
    limitedEdition:[],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHomeProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchHomeProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allProducts = action.payload.allProducts;
        state.newArrivals = action.payload.newArrivals;
        state.topRated = action.payload.topRated;
        state.limitedEdition = action.payload.limitedEdition;
      })
      .addCase(fetchHomeProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default homeSlice.reducer;
